"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Basic = exports.BasicConfiguration = exports.BasicFooter = void 0;
const react_1 = __importDefault(require("react"));
const ElementReferenceFields_1 = require("../../editor/ElementReferenceFields");
const StepNavigation_1 = require("../StepNavigation");
function BasicFooter(props) {
    return react_1.default.createElement(StepNavigation_1.StepNavigation, { onUpdateStep: props.onUpdateStep });
}
exports.BasicFooter = BasicFooter;
function BasicConfiguration({ prefix }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ElementReferenceFields_1.ElementReferenceFields, { prefix: `${prefix}.element` })));
}
exports.BasicConfiguration = BasicConfiguration;
exports.Basic = {
    label: 'Basic',
    renderConfiguration: BasicConfiguration,
    renderFooter: BasicFooter,
};
//# sourceMappingURL=Basic.js.map